module.exports = __webpack_public_path__ + "static/media/raigad.79bcc3b0.jpg";